import { WeightUnit, WeightUnitValues } from '../../../enums/weight-unit';

export const weightUnitEnumFromOrdinal = (ordinalValue) => {
  const defaultEnum = WeightUnit.Ounces;
  const potentialEnumByOrdinal = WeightUnitValues[ordinalValue];

  return potentialEnumByOrdinal ?? defaultEnum;
};
